const userToken = "lawGuideToken"
const OSVERSION = "app0sVersion"
export const setUserTokenStorage = (value) => {
  return localStorage.setItem(userToken, value)
}

export const getUserTokenStorage = () => {
  return localStorage.getItem(userToken)||''
}

export const clearUserTokenStorage = () => {
  return localStorage.removeItem(userToken)
}
export const set0sVersionTokenStorage = (value) => {
  return localStorage.setItem(OSVERSION, value)
}

export const get0sVersionTokenStorage = () => {
  return localStorage.getItem(OSVERSION)|| null
}

export const clear0sVersionTokenStorage = () => {
  return localStorage.removeItem(OSVERSION)
}
